import Viewer from 'viewerjs';

/**
 * Add body class if hero. Makes header transparent & moves hero up.
 */
(() => {
  if (document.querySelector('.transparent-header')) {
    document.body.classList.add('ex-hero');
  } else if (document.querySelector('.ex-content-page')) {
    document.body.classList.add('ex-no-hero');
  }
})();

/**
 * Add logo with white text to header (fromm footer)
 */
(() => {
  document.querySelector('.header-full .logo')?.append(document.querySelector('.sticky-header-logo')?.cloneNode(true));
})();

/**
 * Logged in - update header wuth customer name
 */
(() => {
  const query = document.querySelector('.ex-loggedin');
  if (!query) return;

  document.querySelectorAll('.js-custname').forEach((item) => {
    // eslint-disable-next-line no-undef
    const custName = EvoXLayer().user.name;
    if (!custName) return;

    item.innerHTML = custName.replace(/ .*/, '');
  });
})();

// number count fn
function animateValue(obj, start, end, duration) {
  let startTimestamp = null;
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    obj.innerHTML = Math.floor(progress * (end - start) + start);
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
}

/**
 * Number Count
 */
(() => {
  if (!document.querySelector('.count-boxes')) return;

  const options = {
    rootMargin: '20px 0px',
    threshold: 1.0,
  };

  const callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.count').forEach((count) => {
          const n = count.getAttribute('data-count');
          animateValue(count, 0, n, 2500);
        });
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  const target = document.querySelector('.count-boxes');
  observer.observe(target);
})();

// sticky header
// Add a Sticky header on Scroll

const menubar = document.querySelector('.headersection-1');
const menubarHeader = document.querySelector('.header-full');

//
function stickyMenu() {
  if (document.body.classList.contains('ex-404') && menubar.classList.contains('container')) { return; }
  // change the 65 to the height of the rows above the sticky row
  if (window.pageYOffset >= 1) {
    menubar.classList.add('menubarStick');
    menubarHeader.classList.add('menubarHeader');
  } else {
    menubar.classList.remove('menubarStick');
    menubarHeader.classList.remove('menubarHeader');
  }
}

// scroll event
window.onscroll = () => { stickyMenu(); };

/**
 * Ex-VAT to vatable items
 */
(() => {
  const pdp = document.querySelector('.ex-product');
  if (!pdp) return;

  // add class to product if non-taxable to hide excl-vat
  if (document.querySelectorAll('.product').length) {
    document.querySelectorAll('.product').forEach((currentProd) => {
      if (!currentProd.querySelector('.fa-money-non-taxable')) {
        currentProd.classList.add('is-taxable');
      }
    });
  }

  // PDP
  if (!document.querySelector('.ex-product .productsummary_container .product.is-taxable')) {
    document.querySelector('.product-shopping-actions').classList.remove('is-taxable');
  }
})();

/**
 * Contact Items - rebuild owl carousel
 */
const updateContractSlider = () => {
  // $('.ex-searchresult .wci-content').owlCarousel('destroy');
  $('.ex-searchresult .wci-content').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      991: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
};

$(document).ready(() => {
  // Select the element to observe for changes
  const targetNode = document.querySelector('.ex-searchresult .widget-contract-items-html .temp-text');
  if (!targetNode) return;

  // Create a new observer instance
  const observer = new MutationObserver((mutations) => {
  // Handle the mutations
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
        updateContractSlider();
      }
    });
  });

  // Configure and start the observer
  const config = { childList: true, subtree: true };
  observer.observe(targetNode.parentNode, config);
});

/**
 * Update iframe height on window resize
 */
(() => {
  const query = document.querySelector('iframe[title="YouTube video player"]');
  if (!query) return;

  const calcVideoHeight = (el) => {
    const width = el.offsetWidth;
    const height = width * (9 / 16);
    el.style.height = `${height}px`;
  };

  window.addEventListener('resize', () => {
    document.querySelectorAll('iframe[title="YouTube video player"]').forEach((item) => {
      calcVideoHeight(item);
    });
  });

  // Call the function initially to set the correct height on page load
  document.querySelectorAll('iframe[title="YouTube video player"]').forEach((item) => {
    calcVideoHeight(item);
  });
})();

/**
 * View JS (Image Gallery)
 */
(() => {
  document.querySelectorAll('.gallery-img-list').forEach((gallery) => {
    // eslint-disable-next-line no-new
    new Viewer(gallery, {
      url: 'data-original',
    });
  });
})();

/**
 *
 */
(() => {
  function focusAndPressEnter(input) {
    input.focus();

    const keyupEvent = new KeyboardEvent('keyup', {
      key: 'Enter',
      keyCode: 13,
      code: 'Enter',
      which: 13,
      bubbles: true,
      cancelable: true,
    });

    input.dispatchEvent(keyupEvent);
  }

  const searchUsers = document.querySelector('.myaccount.users #userslist .actionBar input.search-field');
  const icon = document.querySelector('.myaccount.users #userslist .actionBar input.search-field + .icon');

  if (searchUsers && icon) {
    icon.style.cursor = 'pointer';

    icon.addEventListener('click', () => {
      focusAndPressEnter(searchUsers);
    });
  }
})();

/**
 * add trustpilot to footer
 */
(() => {
  const location = document.querySelector('footer.footer .add-trust-pilot');
  if (!location) return;

  const trustpilot = document.createElement('div');
  trustpilot.innerHTML = /* html */`
    <div class="trustpilot-widget" data-locale="en-GB" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="664de70c17b01faefa8150c9" data-style-height="52px" data-style-width="100%">
      <a href="https://uk.trustpilot.com/review/heatons.co.uk" target="_blank" rel="noopener">Trustpilot</a>
    </div>
    `;
  location.appendChild(trustpilot);
})();

/**
 * Moving quicklists in header
 */
(() => {
  const quicklists = document.querySelector('.vuequicklistdropdown_elem');
  if (!quicklists) return;

  const headerLinks = document.querySelector('.head-links');
  if (!headerLinks) return;

  headerLinks.appendChild(quicklists);
})();
